import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { promotionKeys } from "./query-keys";

/** GET /v1/promotions/{id}/activation-precheck — dry-run, no mutation. */
export function usePrecheckActivation(id: string, enabled = false) {
  return useQuery({
    queryKey: promotionKeys.precheck(id),
    enabled: enabled && id.length > 0,
    staleTime: 0,
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/promotions/{id}/activation-precheck", {
        params: { path: { id } },
      });
      /* v8 ignore next -- unreachable: client errorMiddleware throws ApiError on !ok */
      if (error) throw error;
      return data;
    },
  });
}
